import { CanDeactivateFn } from '@angular/router';
import { ApplicationPage } from '../page/application-page/application.page';

export const applicationPageCanDeactivateGuard = (): CanDeactivateFn<ApplicationPage> => {
  return (component, _currentRoute, currentState, nextState) =>
    component.canDeactivate(currentState.url, nextState.url);
};
